export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/tk.8dd19eca.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};